'use es6';

import { getBusinessObjectives } from 'pricing-pages-lib/api/BusinessObjectiveApi';
import { createRequestTypes, createRequestActions } from './RequestActions';
import makeFetchRequest from './makeFetchRequest';
export const FetchBusinessObjectivesRequestTypes = createRequestTypes('BUSINESS_OBJECTIVES');
export const FetchBusinessObjectivesActions = createRequestActions(FetchBusinessObjectivesRequestTypes);
export const fetchBusinessObjectives = ({
  highlightedProducts
}) => dispatch => {
  return makeFetchRequest({
    requestActions: FetchBusinessObjectivesActions,
    fetch: getBusinessObjectives,
    payload: highlightedProducts
  })(dispatch);
};